export default {
      id: "chevron_left-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#chevron_left",
      toString: function () {
        return this.url;
      }
    }